<template>
  <div class="exinfo">
    <!-- 展会简介 -->
    <div class="exinfo-li" v-if="introduction.length">
      <div class="exinfo-msg">
        <div class="exinfo-content">
          <div class="comm_text" :style="{ height: part }" ref="desP" >
            <div v-for="(item,index) in introduction" :key="index">
              <!-- 文本 -->
              <p class="int-text" v-if="item.text" :style="{'font-size':item.text.fontSize,'color':item.text.color,'text-align':item.text.position}" v-html="$service.replaceSpeace(item.text.content)"></p>
              <!-- 图片 -->
              <div class="int-img" v-if="item.picture && item.picture.type == 1" :style="{'padding-left':item.picture.padding+'px','padding-right':item.picture.padding+'px'}">
                <div v-for="(itm,idx) in item.picture.list" :key="idx" :style="{'margin-bottom':item.picture.spacing+'px'}">
                  <img :src="itm.url" preview="1" :preview-text="'exhibitionInfo'" :large="itm.url" v-load="'oIntro'" style="width:100%;display: block" />
                </div>
              </div>
              <div class="comm_banner" style v-if="item.picture && item.picture.type == 2">
                <van-swipe class="my-swipe" :autoplay="4000">
                  <van-swipe-item v-for="(item, index) in item.picture.list" :key="'pic' + index">
                    <img :src="item.url" preview="1" :preview-text="'exhibitionInfo'+index" :large="item.url" style="width: 100%;height: 100%;display: block;" v-load="'oIntro'" />
                  </van-swipe-item>
                </van-swipe>
              </div>
              <!-- 视频 -->
              <div class="int-video" v-if="item.video && item.video.link" style="position:relative;">
                <videoPlayer :url="item.video.link" :cover="item.video.cover" :time="item.video.time" :height="'3.85'"></videoPlayer>
              </div>
            </div>
          </div>
          <!-- <p class="des" :style="{ height: part }" ref="desP" >{{remark}}</p> -->
          <div v-if="desFlag" class="mask"></div>
        </div>
        <p v-if="desFlag" @click="allP()">
          MORE
          <i></i>
        </p>
      </div>
      <!-- <div class="exinfo-main" v-else>
                <p class="no-msg">暂无简介！</p>
      </div>-->
    </div>
    <!-- 组织架构 -->
    <div class="exinfo-li" style="margin: 0 15px">
      <div class="exinfo-content">
        <h2>
          <span style="color: #1890ff">Organization</span>
        </h2>

        <div class="exinfo-main" v-if="OrganList.length">
          <div class="group-list" v-for="(item, index) in OrganList" :key="index">
            <!-- <h3>{{item.Name}}</h3>
          <span v-for="(item,index) in item.child" :key="index" v-html="$service.replaceSpeace(item.Value)"></span>-->
            <h3>{{ item.title }}</h3>
            <span class="van-ellipsis" v-for="(cItem, index) in item.conList" :key="index">{{ cItem }}</span>
          </div>
        </div>
        <div class="exinfo-main" v-else>
          <p class="no-msg">No data！</p>
        </div>
      </div>
    </div>

    <!-- 展会日程 -->
    <div class="exinfo-li" style="margin: 0 15px" v-if="dateList && dateList.length">
      <div class="exinfo-content">
        <h2>
          <span style="color: #1890ff">Schedule</span>
        </h2>
        <div>
          <div class="sche_content">
            <div :style="'bottom: 20px'" class="steps_bar"></div>
            <template v-for="(item,index) in dateList">
              <div :key="'sche-1-' + index" class="sche_item">
                <div class="step">{{index+1}}</div>
                <div class="info" style="width: 80%">
                  <p class="date" v-if="item[0]">{{item[0].startAt | moment('YYYY/MM/DD')}}</p>
                </div>
              </div>
              <div :key="'sche-child-' + index + idx" class="sche_item2" v-for="(it, idx) in item">
                <div class="step"></div>
                <div class="info" style="width: 80%">
                  <p class="date">
                    {{it.startAt | moment('MM/DD HH:mm')}} ~ {{it.endAt | moment('HH:mm')}}
                    <span class="schedule_tag red" v-if="it.state==1">Ing</span>
                    <span class="schedule_tag" v-if="it.state==2">Finished</span>
                  </p>
                  <p :class="it.state==1 ? 'ing' : ''" class="sche_type">{{it.themeEn}}</p>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import card from "./swiperCard.vue";
import { mapActions, mapGetters } from "vuex";
import videoPlayer from "../../product-detail/videoPlayer";
export default {
  name: "exinfo",
  data () {
    return {
      OrganList: [], //组织架构
      part: "",
      desFlag: false,
      Banner: [],
      selectImg: "",
      introduction: [],
      exhibitionConfig: {},
      dateList: [], // 展会日程
    };
  },
  components: { videoPlayer },
  computed: {
    ...mapGetters({
      exhibitionInfo: "getExhibitionInfo",
      userInfo: "getUserInfo",
    }),
    exhibitionId () {
      return this.$route.params.id;
    },
    // remark() {
    //   if(this.exhibitionInfo&&this.exhibitionInfo.exhibition&&this.exhibitionInfo.exhibition.remarkEn){
    //     return this.exhibitionInfo.exhibition.remarkEn
    //   }else{
    //     return ''
    //   }
    // },
  },
  async created () {
    if (!this.userInfo) {
      this.$store.commit("setExhibitionId", this.exhibitionId);
      await this.$Myapollo.getUserInfo(this);
    }
    await this.$Myapollo.getExhibitionInfo(this, this.exhibitionId, this.userInfo.userId);
    this.getOrganList();
    // document.title = this.$t("Headline.exinfo");
    // this.init();
    this.getInfo();
    this.getDate();
  },
  mounted () {
    this.$nextTick(function () {
      if (this.$refs.desP && this.$refs.desP.offsetHeight > 135) {
        // this.part = '135px';
        // this.desFlag = true;
      }
    });
  },
  methods: {
    ...mapActions({
      graphqlPost: "en/graphqlPostByZXS",
    }),
    getInfo () {
      if (this.exhibitionInfo && this.exhibitionInfo.exhibition && this.exhibitionInfo.exhibition.remarkEn.indexOf('[') !== -1) {
        this.introduction = JSON.parse(this.exhibitionInfo.exhibition.remarkEn)
      } else if (this.exhibitionInfo.exhibition.remarkEn) {
        let arr = [{ "text": { "type": 1, "content": this.exhibitionInfo.exhibition.remarkEn, "fontSize": "14px", "color": "#000", "position": "left" } }];
        this.introduction = arr;
      }
    },
    getOrganList () {
      console.log(this.exhibitionInfo.exhibition, "展会信息");
      let organ = this.exhibitionInfo.exhibition.organization;
      let arr = [];
      if (organ && organ.indexOf("[") != -1) {
        arr = JSON.parse(organ);
        console.log(arr, "arr");
        arr.forEach((e) => {
          e.conList = e.contentEn.split("\n");
          e.title = this.getTitle(e.title);
        });
      }
      this.OrganList = arr;
      this.getTitle(this.OrganList);
    },
    init () {
      this.getOrganization();
      this.getBanner();
    },
    getOrganization () {
      this.$http.get("/api/organization?exhibitionid=" + this.exhibitionId, this.$service.v2ApiHeader).then((res) => {
        if (res.status === 200 && res.data) {
          var OrganList = res.data;
          let dataInfo = {};
          OrganList.forEach((item) => {
            let { Name } = item;
            if (!dataInfo[Name]) {
              dataInfo[Name] = {
                Name,
                child: [],
              };
            }
            dataInfo[Name].child.push(item);
          });
          let list = Object.values(dataInfo); // list 转换成功的数据
          this.OrganList = list;
          console.log("OrganList", OrganList);
        }
      });
    },
    getBanner () {
      const reqBody = {
        By: this.exhibitionId,
        Order: "asc",
        condition: [
          { With: "and", Label: "BannerType", Type: "equal", Value: 10 },
          { With: "and", Label: "IsShow", Type: "equal", Value: true },
        ],
        PageSize: 20,
        PageIndex: 1,
      };
      this.$http
        .post("/api/exhibitionbanner/wherepage", reqBody, {
          headers: { "api-version": 2 },
        })
        .then(({ data: { StatusCode, Data } }) => {
          if (StatusCode === 200 && Data) {
            this.Banner = Data.List;
            this.selectImg = this.Banner[0] ? this.Banner[0].ImgUrl : "";
          }
        });
    },
    getTitle (title) {
      let str = "";
      switch (title) {
        case "主办单位":
          str = "Sponsor";
          break;
        case "承办单位":
          str = "Organizer";
          break;
        case "协办单位":
          str = "Co-organizer";
          break;
        case "执行单位":
          str = "Executive unit";
          break;
        case "支持单位":
          str = "Support unit";
          break;
        case "承办单位":
          str = "Organizer";
          break;
        case "指导单位":
          str = "Guidance unit";
          break;
        case "合作单位":
          str = "Cooperation unit";
          break;
        case "批准单位":
          str = "Audit unit";
          break;
        case "友好单位":
          str = "Partner unit";
          break;
        case "媒体合作单位":
          str = "Media unit";
          break;
        case "组织单位":
          str = "Organizer";
          break;
        case "其他":
          str = "Other";
          break;
        default:
          str = title;
          break;
      }
      return str;
    },

    allP () {
      this.$nextTick(function () {
        this.desFlag = false;
        this.part = "auto";
      });
    },
    UpImg (img) {
      this.selectImg = img;
    },
    //获取展会日程
    async getDate () {
      let query = `
        query($where:String!){
          exhibitionScheduleQuery{
           getList(where:$where){
              exhibitionId
              date
              startTime
              endTime
              theme
              themeEn
              speaker
              advert
              address
              organizer
              id
              isDeleted
              createAt
              updateAt
            }
          }
        }
      `;
      let where = {
        Equal: {
          n: "exhibitionId",
          v: this.exhibitionId,
        },
      }
      let opt = {
        query: query,
        variables: {
          where: JSON.stringify(where)
        },
      };
      let res = await this.graphqlPost(opt);
      if (res.data.exhibitionScheduleQuery) {
        let List = JSON.parse(JSON.stringify(res.data.exhibitionScheduleQuery.getList));
        var obj = {}, newArr = [];
        List.sort(function (a, b) {
          return Date.parse(b.startTime.replace(/-/g, "/")) - Date.parse(a.startTime.replace(/-/g, "/"));
        });
        List.forEach(item => {
          let startAt = item.date.slice(0, 11) + item.startTime.slice(11, 19);
          item.startAt = startAt.replace(/-/g, "/");
          let endAt = item.date.slice(0, 11) + item.endTime.slice(11, 19);
          item.endAt = endAt.replace(/-/g, "/");
          item.state = this.compareDate(item.startAt, item.endAt)
          if (item.themeEn) {
            if (!obj[item.startAt.substring(0, 11)]) {
              var arr = [];
              arr.push(item);
              newArr.push(arr);
              obj[item.startAt.substring(0, 11)] = item;
            } else {
              newArr.forEach(value => {
                if (value[0].startAt.substring(0, 11) == item.startAt.substring(0, 11)) {
                  value.push(item)
                }
              })
            }
          }
        })
        newArr.forEach((e => {
          e.sort((a, b) => {
            return Date.parse(a.startTime.replace(/-/g, "/")) - Date.parse(b.startTime.replace(/-/g, "/"));
          })
        }))
        this.dateList = newArr.reverse();
        console.log(this.dateList, '展会日程')
      }
    },
    // 比较时间
    compareDate (statedate, enddate) {
      const stateTime = new Date(statedate).getTime();
      const Time = new Date().getTime();
      const endTime = new Date(enddate).getTime();
      if (stateTime < Time && Time < endTime) {
        return 1; //进行中
      } else if (endTime < Time) {
        return 2; //已结束
      } else {
        return 3; //未开始
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.exinfo {
  &-li {
    border-top: 0.3rem solid #fff;
    h2 {
      padding: 15px;
      color: #333;
      font-weight: bold;
      display: flex;
      align-items: center;
      line-height: 1.2;
      span {
        font-size: 0.28rem;
        font-weight: bold;
      }
      i {
        width: 3px;
        height: 16px;
        background-color: #1890ff;
        margin-right: 5px;
        display: inline-block;
      }
    }
  }
  &-content {
    position: relative;
    padding: 0.35rem 0.2rem;
    background: #fff;
    box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
  }
  &-main {
    padding: 0 15px 15px;
    .group-list {
      margin-bottom: 10px;
      h3 {
        font-size: 0.26rem;
        line-height: 24px;
        color: #333;
      }
      span {
        font-size: 0.24rem;
        line-height: 20px;
        color: #333;
        display: block;
      }
    }
    .group-list:last-child {
      margin-bottom: 0;
    }
  }
  &-msg {
    padding: 0 15px 15px;
  }
  &-last {
    padding: 0 15px 15px;
    .bg-img {
      width: 100%;
      padding-top: 60%;
      position: relative;
      margin-bottom: 10px;
      img {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
      }
    }
  }
}
.no-msg {
  padding: 30px 0;
  text-align: center;
  color: #777;
  font-size: 12px;
}
.mask {
  background-image: linear-gradient(
    0deg,
    #fff 0%,
    rgba(255, 255, 255, 0.85) 58%,
    rgba(255, 255, 255, 0.7) 100%
  );
  width: 100%;
  height: 24px;
  position: absolute;
  bottom: -5px;
  left: 0;
}
.comm_text {
  background: #fff;
  color: #333;
  // padding: 0.35rem 0;
  // margin-bottom: 0.2rem;
  > span {
    line-height: 1;
    padding: 0 0 0.2rem 0.3rem;
    font-size: 0.32rem;
    display: inline-block;
  }
  p {
    line-height: 0.48rem;
    font-size: 0.28rem;
  }
  img {
    display: block;
  }
  .int-text {
    padding: 0.3rem 0;
  }
}
// p {
//   width: 80px;
//   text-align: center;
//   margin: 10px auto 0;
//   color: #4d4d4d;
//   i {
//     border-left: 1px solid #4c4c4c;
//     border-bottom: 1px solid #4c4c4c;
//     height: 8px;
//     width: 8px;
//     transform: translate(2px, -2px) rotate(-45deg);
//     -webkit-transform: translate(2px, -2px) rotate(-45deg);
//     border-right: 1px solid transparent;
//     border-top: 1px solid transparent;
//     display: inline-block;
//     -moz-transform: translate(2px, -2px) rotate(-45deg);
//     -ms-transform: translate(2px, -2px) rotate(-45deg);
//     -o-transform: translate(2px, -2px) rotate(-45deg);
//     margin-left: 5px;
//   }
// }
.des {
  width: 100%;
  font-size: 13px;
  line-height: 24px;
  text-align: left;
  margin: 0;
  color: #333;
  overflow: hidden;
}

.sche_content {
  padding: 0rem 0.3rem;
  position: relative;
  .steps_bar {
    width: 0.04rem;
    position: absolute;
    left: 0.55rem;
    z-index: 0;
    top: 0.5rem;
    bottom: 0;
    background: #ff4550;
  }
  .sche_item {
    display: flex;
    margin-top: 0.48rem;
    position: relative;
    z-index: 1;
    &.end {
      .sche_type {
        color: #999;
      }
    }
    .step {
      margin-right: 0.27rem;
      width: 0.52rem;
      height: 0.52rem;
      line-height: 0.54rem;
      border-radius: 50%;
      background: linear-gradient(to left, #ff416c, #ff4b2b);
      color: #fff;
      font-size: 0.26rem;
      text-align: center;
    }
    .info {
      font-size: 15px;
      color: #ff5c00;
      display: flex;
      align-items: center;
    }
    .sche_user {
      display: flex;
      color: #333;
      img {
        width: 0.36rem;
        height: 0.36rem;
        object-fit: cover;
        display: block;
        margin-right: 0.1rem;
        border-radius: 50%;
      }
    }
  }
  .sche_item2 {
    display: flex;
    margin-top: 0.48rem;
    position: relative;
    z-index: 1;
    &.end {
      .sche_type {
        color: #999;
      }
    }
    .step {
      margin: 0 0.39rem 0 0.14rem;
      width: 0.24rem;
      height: 0.24rem;
      line-height: 0.54rem;
      border-radius: 50%;
      background: linear-gradient(to left, #ff416c, #ff4b2b);
      color: #fff;
      font-size: 0.26rem;
      text-align: center;
    }
    .date {
      line-height: 0.28rem;
      height: 0.28rem;
      font-size: 0.24rem;
      margin-bottom: 0.12rem;
      font-size: 0.24rem;
      color: #999;
      .schedule_tag {
        font-size: 0.24rem;
        vertical-align: middle;
        padding: 0.02rem 0.06rem;
        border-radius: 0.03rem;
        display: inline-block;
        background: #e6e6e6;
        color: #666;
        margin-left: 10px;
      }
      .red {
        background-color: #ff4550;
        color: #fff;
      }
    }
    .sche_type {
      line-height: 1.5em;
      margin-bottom: 0.14rem;
      font-size: 0.24rem;
      color: #999;
      span {
        color: #666;
        margin-left: 0.3rem;
      }
    }
    .ing {
      color: #333;
    }
    .msg {
      display: flex;
      img {
        width: 0.84rem;
        height: 0.84rem;
        object-fit: cover;
        display: block;
        margin-right: 0.12rem;
        border-radius: 0.03rem;
        &:last-child {
          margin-right: 0;
        }
      }
    }
    .sche_user {
      display: flex;
      color: #333;
      img {
        width: 0.36rem;
        height: 0.36rem;
        object-fit: cover;
        display: block;
        margin-right: 0.1rem;
        border-radius: 50%;
      }
    }
  }
}
</style>
